import { render, staticRenderFns } from "./NewDocument.vue?vue&type=template&id=086f6946&scoped=true"
import script from "./NewDocument.vue?vue&type=script&lang=js"
export * from "./NewDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f6946",
  null
  
)

export default component.exports